import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const OnTheGrid = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query HowItWorksOnTheGridHeroImageQuery {
          file(relativePath: { eq: "on_grid.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 100% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 63% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 33px 46px 47px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 382px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          width: 420px;
          padding: 30px 38px 38px 38px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 40px 48px 48px 48px;
          width: 452px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 76px 80px;
        }
      `}
    >
      <Header2>
        {"On the Grid"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize(
                "default"
              )}) and (max-width: 479px) {
              margin-top: 15px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 19px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 767px) {
            margin-top: 18px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1199px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            margin-top: 21px;
          }
        `}
      >
        {
          "Monitor energy consumption on every circuit in your electrical panel to help you make smarter energy decisions. Take advantage of Time-of-Use energy rates by drawing on your stored energy or on-site energy generation automatically. Avoid purchasing energy during peak price hours and lower your energy bill."
        }
      </Paragraph>
    </Card>
  </Section>
);
